import React from 'react';

import { SortItem } from '@models/Sort';
import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  button: {
    ...common.middleText,
    color: theme.palette.grey[800],
    cursor: 'pointer',
  },
  buttonSelected: {
    color: theme.palette.primary.main,
  },
  buttonPadding: {
    display: 'inline-block',
    width: 20,
    color: theme.palette.common.black,
    textAlign: 'center',
  },
}));

interface SortButtonProps {
  title: string;
  selected?: boolean;
  onSelect?: () => void;
}

const SortButton: React.FC<SortButtonProps> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };
  const { title, selected = false, onSelect = undefined } = props;

  return (
    <span
      className={clsx(classes.button, selected && classes.buttonSelected)}
      onClick={() => {
        if (!selected) {
          onSelect?.();
        }
      }}
    >
      {title}
    </span>
  );
};

const SortButtonsSeparator: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return <span className={classes.buttonPadding}>|</span>;
};

export interface SortButtonsProps {
  currentSortKey?: string;
  items: SortItem[];
  onSortKeyChanged?: (newSortKey: string) => void;
}

export const SortButtons: React.FC<SortButtonsProps> = (props) => {
  const { items, currentSortKey, onSortKeyChanged } = props;

  let selectedSortKey = currentSortKey;
  if (currentSortKey === undefined && items.length > 0) {
    selectedSortKey = items[0].sortKey;
  }

  return (
    <div>
      {items.map((item, index) => (
        <span key={String(index)}>
          {index > 0 && <SortButtonsSeparator />}
          <SortButton
            title={item.title}
            selected={selectedSortKey === item.sortKey}
            onSelect={() => {
              onSortKeyChanged?.(item.sortKey);
            }}
          />
        </span>
      ))}
    </div>
  );
};
